import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router';
import { Alert, Modal, ModalBody, ModalHeader, Spinner } from 'reactstrap';
import { Button, Col, Icon, Row, RSelect } from '../../../Component';
import { ADMIN_ADD_MODULE_TO_TENANT_API, ADMIN_RETRIEVE_ADD_TENANT_TO_MODULE_DATA_API } from '../../../../api/api_data';
import { tenant_auth_actions_helper } from '../../../../actions/actions_helper';
import { fail_retrieve_add_tenant_to_module_data, loading_retrieve_add_tenant_to_module_data, reset_retrieve_add_tenant_to_module_data, success_retrieve_add_tenant_to_module_data } from '../../../../reducers/auth_tenant/retrieve_add_tenant_to_module_data_Slice';
import { ADD_MODULE_TO_TENANT_ERROR_MSG, ADD_MODULE_TO_TENANT_SUCCESS_MSG, COULD_NOT_RETRIEVE_DATA_ERROR_MSG, COULD_NOT_RETRIEVE_DATA_SUCCESS_MSG } from '../../../../utils/error_success_messages';
import { useSelector } from 'react-redux';
import { messageToast } from '../../../../utils/Utils';
import * as app_consts from "../../../../utils/app_consts";
import TextInput from '../../../../pages/components/inputs/TextInput';
import { fail_add_module_to_tenant, loading_add_module_to_tenant, reset_add_module_to_tenant, success_add_module_to_tenant } from '../../../../reducers/auth_tenant/add_module_to_tenant_Slice';

const initialState = { module: "", tenant_id: "" };

const AdminAddModuleToTenantModal = ({ tenant_info, user_info, isOpen, successFunction, closeModal, tenant_id }) => {

  const [open, setOpen] = useState(isOpen);
  const [loading, setLoading] = useState(true);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [error, setError] = useState("");
  const [formData, setFormData] = useState(initialState);
  const [sent_tenant_id, setSentTenantId] = useState(tenant_id);
  const [page_data, setPageData] = useState([]);
  const [submit_loading, setSubmitLoading] = useState(false);
  const [submit_error, setSubmitError] = useState("");


  useEffect(() => {
    setFormData({ ...initialState, tenant_id: tenant_id });
    setSentTenantId(initialState);
    setLoading(true);
    setSubmitError("");
    setError("");
    setOpen(isOpen);
    if (isOpen && tenant_id)
    {
      retrieve_data(tenant_id);
    }
  }, [isOpen, tenant_id]);

  const retrieve_data = (id) => {
    setError("");
    // Dispatch
    dispatch(tenant_auth_actions_helper(loading_retrieve_add_tenant_to_module_data, success_retrieve_add_tenant_to_module_data, fail_retrieve_add_tenant_to_module_data, COULD_NOT_RETRIEVE_DATA_ERROR_MSG, COULD_NOT_RETRIEVE_DATA_SUCCESS_MSG, app_consts.GET, `/${tenant_info?.url_prefix}/${ADMIN_RETRIEVE_ADD_TENANT_TO_MODULE_DATA_API}/${id}`));
  };
  // Listener
  const retrieve_add_tenant_to_module_data_listener = useSelector((state) => state.retrieve_add_tenant_to_module_data.retrieve_add_tenant_to_module_data);

  useEffect(() => {
    if (retrieve_add_tenant_to_module_data_listener.status !== app_consts.IDLE)
    {
      if (retrieve_add_tenant_to_module_data_listener.status === app_consts.LOADING)
      {
        setLoading(true);
        setError("");
      } else
      {
        if (retrieve_add_tenant_to_module_data_listener.status === app_consts.FAIL)
        {
          setError(retrieve_add_tenant_to_module_data_listener.message);
          messageToast(retrieve_add_tenant_to_module_data_listener.message, app_consts.FAIL);
        } else if (retrieve_add_tenant_to_module_data_listener.status === app_consts.SUCCESS)
        {
          setPageData(retrieve_add_tenant_to_module_data_listener.data);
        }
        setLoading(false);
        dispatch(reset_retrieve_add_tenant_to_module_data());
      }
    }
  }, [retrieve_add_tenant_to_module_data_listener]);

  const handleSubmit = () => {
    setSubmitError("");
    // Dispatch
    dispatch(tenant_auth_actions_helper(loading_add_module_to_tenant, success_add_module_to_tenant, fail_add_module_to_tenant, ADD_MODULE_TO_TENANT_ERROR_MSG, ADD_MODULE_TO_TENANT_SUCCESS_MSG, app_consts.POST, `/${tenant_info?.url_prefix}/${ADMIN_ADD_MODULE_TO_TENANT_API}`, formData));
  };
  // Listener
  const add_module_to_tenant_listener = useSelector((state) => state.add_module_to_tenant.add_module_to_tenant);

  useEffect(() => {
    if (add_module_to_tenant_listener.status !== app_consts.IDLE)
    {
      if (add_module_to_tenant_listener.status === app_consts.LOADING)
      {
        setSubmitLoading(true);
        setSubmitError("");
      } else
      {
        if (add_module_to_tenant_listener.status === app_consts.FAIL)
        {
          setSubmitError(add_module_to_tenant_listener.message);
          messageToast(add_module_to_tenant_listener.message, app_consts.FAIL);
        } else if (retrieve_add_tenant_to_module_data_listener.status === app_consts.SUCCESS)
        {
          messageToast(ADD_MODULE_TO_TENANT_SUCCESS_MSG, app_consts.SUCCESS);
          successFunction();
          closeModal();
        }
        setSubmitLoading(false);
        dispatch(reset_add_module_to_tenant());
      }
    }
  }, [add_module_to_tenant_listener]);

  return (
    <>
      <Modal isOpen={open} toggle={closeModal} className="modal-dialog-centered" size="md">
        <ModalHeader toggle={loading || submit_loading ? "" : closeModal}>Add Module to Tenant</ModalHeader>
        <ModalBody>
          {
            loading ?
              <>
                <div className="w-70 m-auto d-flex flex-column justify-content-center align-center" style={{ height: "200px" }} >
                  <div className="text-soft fw-bold" style={{ fontSize: 24, marginTop: "90px" }}>Retrieveing Data...</div>
                  <div className="nk-loader mt-2  w-70 m-auto "></div>
                </div>
              </>
              :
              <>
                {
                  error ?
                    <>
                      <div className="w-70 m-auto d-flex flex-column justify-content-center align-center" style={{ height: "200px" }} >
                        <div className="text-soft fw-bold" style={{ fontSize: 24, marginTop: "90px" }}>{error}</div>
                      </div>
                    </>
                    :
                    <>
                      <Row className="g-4">
                        <TextInput
                          label="Tenant Name"
                          type="text"
                          id_val="tenant_name"
                          value={page_data?.tenant?.name}
                          colSize="12"
                          name="tenant_name"
                          disabled
                        />
                        <Col size={12}>
                          <div className="form-group">
                            <label className="form-label mb-1 text-md" htmlFor="module">
                              Module<span className='text-danger pr-2'>{` *`}</span>
                            </label>
                            <div className="w-100">
                              <RSelect
                                options={page_data?.modules || []}
                                className="w-100"
                                placeholder="Search"
                                id="module"
                                onChange={(e) => {
                                  setFormData({ ...formData, ["module"]: e.value });
                                }}
                              />
                            </div>
                          </div>
                        </Col>
                        {submit_error && (
                          <div className="mb-3 w-100">
                            <Alert color="danger" className="alert-icon">
                              <Icon name="alert-circle" /> {submit_error}{" "}
                            </Alert>
                          </div>
                        )}
                        <Col xl="12" className="d-flex justify-content-end mt-4 mr-2">
                          <Button onClick={handleSubmit} disabled={submit_loading || !(formData?.module && formData?.tenant_id)} color="primary">
                            {submit_loading ? <Spinner size="sm" color="light" /> : "Add Module"}
                          </Button>
                        </Col>
                      </Row>
                    </>
                }
              </>
          }
        </ModalBody>
      </Modal>
    </>
  );
};

export default AdminAddModuleToTenantModal;